<template>
  <div id="my-staff-item">
    <vx-card
      class="shadow-md staff-item"
      :class="{'is-selected': this.isSelected, 'dense': dense}"
      v-if="type=='grid'"
    >
      <div class="flex align-center p-3">
        <vs-avatar
          class="border-2 border-solid border-grey text-3xl"
          size="65px"
          :text="StringHelper.changeFormatAvatar(staffData.name)"
          :src="staffImage"
          :color="colorCode"
          style="min-width: 65px"
        ></vs-avatar>
        <div class="ml-2 overflow-hidden">
          <div
            class="font-bold text-lg"
            style="max-width: 100%; overflow: hidden; text-overflow: ellipsis; display: inline-block; white-space: nowrap;"
          >{{staffData.name}}</div>
          <vs-alert class="flex align-center justify-center text-sm staff-type">Staff</vs-alert>
        </div>
      </div>
    </vx-card>

    <div v-if="type=='list'">
      <div class="w-full border-top-custom staff-item" :class="{'is-selected': this.isSelected}">
        <div class="flex align-center justify-between p-2">
          <div class="flex align-center overflow-hidden">
            <vs-avatar
              class="border-2 border-solid border-grey text-xl"
              size="40px"
              :text="StringHelper.changeFormatAvatar(staffData.name)"
              :src="staffImage"
              :color="colorCode"
              style="min-width: 40px"
            ></vs-avatar>
            <div
              class="font-bold text-lg ml-2 overflow-hidden"
              style="max-width: 100%; overflow: hidden; text-overflow: ellipsis; display: inline-block; white-space: nowrap;"
            >{{staffData.name}}</div>
          </div>
          <div class="ml-2">
            <vs-alert class="flex align-center justify-center text-sm staff-type">Staff</vs-alert>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { StringHelper } from "../models/string_helper";
export default {
  name: "my-staff-item",
  props: {
    staffData: {
      type: Object
    },
    isSelected: {
      type: Boolean
    },
    type: {
      type: String,
      default: "grid"
    },
    dense: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    staffImage() {
      if (
        this.staffData.image_url == null ||
        this.staffData.image_url == "deleted"
      ) {
        return null;
      }
      return this.staffData.image_url;
    },
    colorCode() {
      if (this.staffData.color_code == null) {
        return this.$store.getters["staffList/themeColors"][1];
      }
      return this.staffData.color_code;
    }
  },
  data() {
    return {
      StringHelper
    };
  }
};
</script>
<style lang="scss">
@import "@/assets/scss/vuexy/_variables";
#my-staff-item {
  .staff-item {
    transition: 0.2s ease;
    &:hover {
      transform: translateY(-2px);
      cursor: pointer;
      background: rgba($primary, 0.03);
    }
    &.dense {
      .vx-card__body {
        padding: 0 !important;
      }
    }
  }
  .is-selected {
    -webkit-transform: translate(0) !important;
    transform: translate(0) !important;
    background: rgba(41, 121, 255, 0.5) !important;
    background-image: initial !important;
    background-position-x: initial !important;
    background-position-y: initial !important;
    background-size: initial !important;
    background-repeat-x: initial !important;
    background-repeat-y: initial !important;
    background-attachment: initial !important;
    background-origin: initial !important;
    background-clip: initial !important;
    background-color: rgba(41, 121, 255, 0.25) !important;
  }

  .is-selected {
    color: rgba($primary, 1);
    -webkit-box-shadow: 0 0 1px 0 rgba($primary, 1) !important;
    box-shadow: 0 0 1px 0 rgba($primary, 1) !important;
  }
  .staff-type {
    width: 70px;
    height: 25px !important;
  }
}
</style>